module.exports = {
  BRAND: 'DevPtt2',
  API_ROOT: 'https://api.devptt.dev',
  CLIENT_ID: 'test_web_client_id',
  CLIENT_SECRET: 'test_web_client_secret',
  TERM_URL: 'https://term.devptt.dev',
  LIST_LIMIT: 150,
  PTT_GUEST: 'guest',
}
